import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { ApiErrorResponse, ApiResponse } from '@/types/api';
import { api } from '@/utils/api';

export type PlanType = 'monthly' | 'yearly';

export interface PlanItemType {
  id: number;
  type: PlanType;
  name: string;
  price: number;
  totalPrice: number;
  status: 'upgrade' | 'new' | 'same' | 'downgrade' | 'next';
}

export interface GetPayPlanResponse {
  plan: PlanItemType[];
}

export const getPayPlan = () => {
  return api.get<ApiResponse<GetPayPlanResponse>>('/pay/plan');
};

const usePayPlan = <
  TData = AxiosResponse<ApiResponse<GetPayPlanResponse>>,
  TError = AxiosError<ApiErrorResponse>,
>(
  options?: UseQueryOptions<
    AxiosResponse<ApiResponse<GetPayPlanResponse>>,
    TError,
    TData,
    ['getPayPlan']
  >,
): UseQueryResult<TData, TError> => {
  return useQuery(['getPayPlan'], () => getPayPlan(), { ...options });
};

export default usePayPlan;
